module.exports = __webpack_public_path__ + "img/Protractor-01.f4352e0f.png";